import { asAmount, asProfitAndLoss, BondPriceNominal, Money, ProfitAndLoss } from "@goodfill/domain-properties";

export const calculateProfitAndLoss = (
  value: Money,
  loadedBuyPrice: BondPriceNominal,
  loadedSellPrice: BondPriceNominal,
): ProfitAndLoss =>
  asProfitAndLoss({
    amount: asAmount(value.amount.mul(loadedSellPrice.minus(loadedBuyPrice))),
    currency: value.currency,
  });
